import React, { useState } from 'react';
import {
  AddressSearch,
  AddressSearchProps,
  PlacesSearchProps,
} from 'components';
import AddElement from './AddElement';
import Label from './Label';

interface AddHomeAddressProps {
  onSelectOption: PlacesSearchProps['onSelect'];
  onInputChange: AddressSearchProps['onInputChange'];
}

const AddHomeAddress: React.FC<AddHomeAddressProps> = ({
  onInputChange,
  onSelectOption,
}) => {
  const [active, setActive] = useState(false);

  const onSelect: typeof onSelectOption = prediction => {
    setActive(false);
    onSelectOption(prediction);
  };

  return active ? (
    <>
      <Label label="Home Address" />
      <AddressSearch
        autoFocus
        type="places"
        onSelect={onSelect}
        onInputChange={onInputChange}
      />
    </>
  ) : (
    <AddElement label="Home Address" onClick={() => setActive(true)} />
  );
};

export default AddHomeAddress;
